import { State } from "../fstn/state";

const stillPattern = /STILL\((.*)\)/;
const commentPattern = /(.*)[\s]*---/s;

interface ScriptParts
{
    stillSource?: string;
    text?: string;
}

export function parseScriptParts(state: State): ScriptParts
{
    let res: ScriptParts = {};
    let script = state.script;

    if (script)
    {
        const stillMatches = script.match(stillPattern)

        if (stillMatches)
        {
            res.stillSource = stillMatches[1];
            script = script.replace(stillMatches[0], "");
        }

        const commentMatches = script.match(commentPattern);

        if (commentMatches)
        {
            script = commentMatches[1];
        }

        res.text = script;
    }

    return res;
}
